<template>
  <mdb-btn class="m-0 p-1" icon="list" @click="$emit('click')"><slot/></mdb-btn>
</template>
<script>
export default {
  name: 'ListBtnSm'
}
</script>
